app.controller("FreshStudentExamsIndexController", [
    "$scope", "Lecturer", "Users", "FreshModal", "ConfirmModal", "$stateParams", "StaticData", "$http", "toastr", "usSpinnerService", "StudentExamsService",
    function ($scope, Lecturer, Users, FreshModal, ConfirmModal, $stateParams, StaticData, $http, toastr, usSpinnerService, StudentExamsService) {
        $scope.query = $stateParams.query;
        $scope.schedule = [];
        $scope.reseats = [];
        $scope.isEmpty = false;
        $scope.isEmptyReseat = false;
        $scope.supportUrl = null;
        $scope.scheduleUrl = null;

        $scope.statuses = {
            approved: "ნებადართული",
            conditional: "წინაპირობით დაშვება",
            pending: "მომლოდინე",
            rejected: "უარყოფილი"
        };

        StaticData.getItemsByKey("exam-schedule").then(function (data) {
            $scope.scheduleUrl = data[0].value;
        });

        $scope.fetchList = function () {
            $scope.isEmpty = false;
            StudentExamsService.getExamList().then(function (res) {
                $scope.schedule = res.data.filter(function (val) {
                    return val.status === 'approved' || val.status === 'conditional';
                });
                if ($scope.schedule && $scope.schedule.length === 0) {
                    $scope.isEmpty = true;
                }
                $scope.reseats = res.data.filter(function (val) {
                    return val.status !== 'approved' && val.status !== 'conditional';
                });
                if ($scope.reseats && $scope.reseats.length === 0) {
                    $scope.isEmptyReseat = true;
                }
                // usSpinnerService.stop("root");
            }, function () {
                $scope.isEmpty = true;
                $scope.isEmptyReseat = true;
                // usSpinnerService.stop("root");
            });
        };

        $scope.move = function (item) {
            if (item.canMove) {
                FreshModal.open({
                    controller: "FreshStudentExamsMoveItemController",
                    templateUrl: _pb + 'student-new/exams/exams-move-item.html',
                    size: "md",
                    resolve: {
                        params: function () {
                            return {examItem: item};
                        }
                    }
                }).then(function () {
                    $scope.fetchList();
                }, function () {
                });
            } else {
                return toastr.error('', 'გამოცდის გადატანა არ არის შესაძლებელი!');
            }

        };

        $scope.requestReseat = function () {
            FreshModal.open({
                controller: "FreshStudentExamsRequestReseatController",
                templateUrl: _pb + 'student-new/exams/exams-request-reseat.html',
                size: "md",
                resolve: {}
            }).then(function () {
                $scope.fetchList();
            }, function () {
            });
        };

        $scope.goToURL = function () {
            StaticData.loadStatics().then(function () {
                StaticData.getItemsByKey("exam-center-support").then(function (data) {
                    $scope.supportUrl = data[0].value;
                    window.open($scope.supportUrl)
                });
            });
        };

        $scope.downloadSchedule = function () {
            window.open($scope.scheduleUrl);
        };

        $scope.fetchList();
    }
]);
